var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#0A89E0;}\n\t.st2{fill:#53ADF8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,18C1,22.2,1,29.1,5.1,33.4l24.5,25.4l1.6,1.7l0,0c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2l6.2-6.4 c1.4-1.4,1.4-3.7,0-5.1c-1.4-1.4-3.6-1.4-4.9,0l-6.2,6.4c-1.4,1.4-3.6,1.4-5,0l0,0L10,28.4c-1.4-1.4-1.4-3.7,0-5.1l12.4-12.8 c1.4-1.4,3.6-1.4,5,0L38.7,22c1.4,1.4,3.6,1.4,4.9,0c1.4-1.4,1.4-3.7,0-5.1L32.3,5.2C28.2,1,21.5,1,17.5,5.2L5.1,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,69c-1.4,1.4-1.4,3.7,0,5.1l11.3,11.7c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2L82.9,73 c4.1-4.2,4.1-11.1,0-15.4l-26.1-27c-4.1-4.2-10.8-4.2-14.8,0L35.8,37c-1.4,1.4-1.4,3.7,0,5.1c1.4,1.4,3.6,1.4,4.9,0l6.2-6.4 c1.4-1.4,3.6-1.4,5,0l26.1,27c1.4,1.4,1.4,3.7,0,5.1L65.6,80.7c-1.4,1.4-3.6,1.4-5,0L49.3,68.9C48,67.5,45.8,67.5,44.4,69z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,30.4c0-2.5,1.8-4.5,4-4.5s4,2,4,4.5v22.5c0,2.5-1.8,4.5-4,4.5H33.1c-2.2,0-4-2-4-4.5s1.8-4.5,4-4.5h10 L13.3,14.1c-1.5-1.8-1.5-4.5,0-6.3c0.8-0.9,1.8-1.4,2.9-1.4s2.1,0.5,2.9,1.4l29.4,33.9V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.2,38.1c2.2,0,4,2,4,4.5v9.3c0,10.7,1.7,17.6,5.4,21.9C18.3,78,24.3,80,33.5,80h24.2c9.2,0,15.1-2,18.8-6.2 c3.7-4.3,5.4-11.2,5.4-21.9v-9.4c0-0.4,0.1-0.8,0.2-1.2c-0.1-0.4-0.2-0.8-0.2-1.2c0-10.7-1.7-17.6-5.4-21.9 C72.8,14,66.9,12,57.7,12h-8.1c-2.2,0-4-2-4-4.5s1.8-4.5,4-4.5h8.1C69.2,3,77,5.8,82.3,11.9c5.2,6.1,7.7,15,7.7,28.2 c0,0.4-0.1,0.8-0.2,1.2c0.1,0.4,0.2,0.8,0.2,1.2v9.4c0,13.2-2.4,22.1-7.7,28.2C77,86.2,69.2,89,57.7,89H33.5 C22,89,14.2,86.2,8.9,80.1c-5.2-6.1-7.7-15-7.7-28.2v-9.3C1.2,40.1,3,38.1,5.2,38.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.dc0cf5505277e92907ac5693a5bd87a5.svg";
export { ForwardRef as ReactComponent };